import { useState } from "react";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { SESSION_KEYS } from "src/consts/session";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { Alert, Snackbar, SnackbarCloseReason, Stack } from "@mui/material";
import { selfOnboardingAuthenticationUrl } from "src/api/selfOnboardingClients";

const Access = () => {
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("translation");
  const [isLoading, setIsLoading] = useState(false);

  const [getTransferId] = useSessionStorage<string>(SESSION_KEYS.TRANSFER_ID);
  const [getOemSelected] = useSessionStorage<string>(
    SESSION_KEYS.SELF_ONBOARDING_OEM_SELECTED,
  );

  const handleNextClick = async () => {
    setIsLoading(true);
    try {
      const transferId = getTransferId();
      const oemId = getOemSelected();
      if (!transferId || !oemId) return;

      const authenticationUrlResponse = await selfOnboardingAuthenticationUrl({
        transferId,
      });
      window.location.href = authenticationUrlResponse.authenticationUrl;
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    } catch (e) {
      const error = e as Error;
      setIsLoading(false);
      setMsg(error.msgId ?? "");
      setOpen(true);
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack gap={5}>
      <Text
        text={t("page.siteAuthenticationStart.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.siteAuthenticationStart.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <PrimaryButton
        fullWidth
        onClick={handleNextClick}
        text={t("page.siteAuthenticationStart.nextButton")}
        sx={(theme) => ({
          fontSize: "14px",
          lineHeight: "20px",
          maxWidth: { sm: "320px" },
          color: theme.palette.mainFont.primary,
        })}
        isLoading={isLoading}
      />

      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert
          severity="error"
          variant="filled"
          onClose={handleClose}
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default Access;
